const firebaseConfig = {
  apiKey: "AIzaSyBFH4VUeLWCwlOsFP4w5M4MFF86FTCIYhY",
  authDomain: "dry-clean-67773.firebaseapp.com",
  projectId: "dry-clean-67773",
  storageBucket: "dry-clean-67773.appspot.com",
  messagingSenderId: "259970410316",
  appId: "1:259970410316:web:3bee464f5b2ae9cc1291e9"
};

export default firebaseConfig;